import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,  // send httpOnly admin session cookie on every request
});

// Fire-and-forget conversion event tracker.
// Whitelisted event names are handled server-side; other names are silently ignored.
export function trackEvent(name, extra = {}) {
  try {
    api.post("/track/event", {
      name,
      path: typeof window !== "undefined" ? window.location.pathname : "",
      ...extra,
    }).catch(() => {});
  } catch { /* ignore */ }
}

export const COURSES = {
  weave_leaveout: {
    id: "weave_leaveout",
    name: "Weave Met Leave-Out",
    subtitle: "Middle Part · PTR Methode",
    dateLine: "17 · 18 · 19 Juli",
    dateChips: ["17", "18", "19"],
    dateMonth: "Juli",
    schedule: [
      "Vrijdag — 11:00 tot 18:00",
      "Zaterdag — 11:00 tot 18:00",
      "Zondag — 11:00 tot 18:00",
    ],
    price: 1500,
    totalSpots: 6,
    requiresBraidingSkill: true,
  },
  closure_wig: {
    id: "closure_wig",
    name: "Closure Wig Cursus",
    subtitle: "Maken & Customizen",
    dateLine: "31 Juli · 1 · 2 Augustus",
    dateChips: ["31", "01", "02"],
    dateMonth: "Jul / Aug",
    schedule: [
      "Vrijdag — 11:00 tot 18:00",
      "Zaterdag — 11:00 tot 18:00",
      "Zondag — 11:00 tot 18:00",
    ],
    price: 1000,
    totalSpots: 6,
    requiresBraidingSkill: false,
  },
  flip_sewin: {
    id: "flip_sewin",
    name: "Flip-Method Cursus",
    subtitle: "Geavanceerde Sew-In Techniek",
    dateLine: "18 · 19 · 20 September",
    dateChips: ["18", "19", "20"],
    dateMonth: "September",
    schedule: [
      "Vrijdag — 11:00 tot 18:00",
      "Zaterdag — 11:00 tot 18:00",
      "Zondag — 11:00 tot 18:00",
    ],
    price: 1500,
    totalSpots: 6,
    requiresBraidingSkill: true,
  },
};

export const COURSE_LIST = [
  COURSES.weave_leaveout,
  COURSES.closure_wig,
  COURSES.flip_sewin,
];

// Hero trust points
export const HERO_TRUST = [
  "Kleine groepen",
  "Persoonlijke begeleiding",
  "Alle materialen inbegrepen",
  "18 uur praktijktraining",
];

// "Wat kun jij na deze cursus?"
export const RESULTS = [
  "Zelfstandig een professionele weave plaatsen",
  "Een platte en natuurlijke installatie creëren",
  "Meer vertrouwen krijgen in je werk",
  "Nieuwe technieken leren",
  "Je diensten uitbreiden als hairstylist",
];

// "Wat is inbegrepen?" — under each course price
export const INCLUDED_DETAILED = [
  "Professionele training",
  "Wig stand",
  "Oefenhoofd",
  "Naald en draad",
  "Weaving net",
  "Producten",
  "Flat iron",
  "Eten & drinken",
  "Alle materialen inbegrepen",
];

// "Waarom boeken via deze website?"
export const TRUST_BOOKING = [
  "Veilige registratie",
  "Beveiligde betaling",
  "Directe bevestiging per e-mail",
  "WhatsApp ondersteuning",
];

// About trainer
export const TRAINER = {
  name: "Quimarich",
  role: "Founder & Hoofdtrainer • Pattern Texture",
  intro: "Met meer dan 13 jaar ervaring in de haarbranche leer ik hairstylisten hoe ze platter kunnen weven, duurzamere installaties creëren en meer klanten behouden.",
  passion: "Mijn missie is om mijn kennis door te geven, zodat jij kunt groeien in techniek, zelfvertrouwen en inkomen.",
  photo: "https://customer-assets.emergentagent.com/job_leave-out-pro/artifacts/7hkknj1v_IMG_9377.jpg",
};

// Goodie bag photo shown in "Wat is inbegrepen?"
export const GOODIE_BAG_PHOTO = "https://customer-assets.emergentagent.com/job_leave-out-pro/artifacts/qrt7249g_12C2FC49-4EA9-47C9-B6DA-74293DBAC644.PNG";

// Course info dialog content (Dutch)
export const COURSE_INFO = {
  weave_leaveout: {
    summary: "Leer hoe je een professionele weave plaatst met een natuurlijk uitziende middle part, volgens de Pattern Texture (PTR) methode.",
    points: [
      "Middle-part braid pattern",
      "Platte sew-in technieken",
      "Leave-out blenden",
      "Praktijk op een model",
    ],
    perfectFor: "Beginners die al kunnen vlechten en professionele installaties willen leren.",
  },
  flip_sewin: {
    summary: "Leer de flip-method sew-in — een geavanceerde techniek voor natuurlijke, platte installaties.",
    points: [
      "Flip-method braid pattern",
      "Platte track placement",
      "Natuurlijke install technieken",
      "Praktijk op een model",
    ],
    perfectFor: "Hairstylisten die de flip-method aan hun skills willen toevoegen.",
  },
  closure_wig: {
    summary: "Leer hoe je een mooie closure wig van begin tot eind maakt en customiseert.",
    points: [
      "Closure placement",
      "Wig constructie",
      "Knot bleaching",
      "Lace customization",
      "Basis styling",
    ],
    perfectFor: "Iedereen die zijn/haar eigen professionele wigs wil leren maken.",
  },
};

export const WHAT_YOU_LEARN = [
  "Pattern braiding (basis voor de install)",
  "Werken met één draad",
  "Hoe je de naald correct knoopt",
  "Double knot & loop methode",
  "Weaving net plaatsen",
  "Bundle placement",
  "Hoek-plaatsing voor platte resultaten",
  "Double weft placement",
  "Back sew finishing techniek",
  "Leave-out blenden",
  "Basis styling",
];

export const INFO_BAR = [
  "3-Daagse Intensieve Cursus",
  "18 Uur Praktijktraining",
  "Kleine Groep",
  "Hands-On Leren",
  "Professionele Technieken",
];

export const CONTACT_PHONE = "Quimarich  •  06 21 27 81 50";
export const CONTACT_EMAIL = "patterntexture@gmail.com";
export const BRAND_NAME = "Pattern Texture Room";
export const INSTAGRAM_HANDLE = "Pt.salon.room";
export const INSTAGRAM_URL = "https://www.instagram.com/Pt.salon.room/";
export const WHATSAPP_CHANNEL_URL = "https://whatsapp.com/channel/0029VbCGgtcFSAt1gfv6aK0E";
// Direct WhatsApp DM link with pre-filled Dutch question
export const WHATSAPP_DM_URL = "https://wa.me/31621278150?text=" + encodeURIComponent("Hoi! Ik heb een vraag over de Pattern Texture cursus.");

export const WHATS_INCLUDED = [
  "Naalden",
  "Vlechthaar",
  "Kammen",
  "Clips",
  "Weaving net",
  "Draad",
  "Wig stand",
  "Haarproducten",
  "Flat iron",
  "Mini flat iron",
  "Haarspray",
];

export const REFERRAL_SOURCES = [
  "Instagram",
  "TikTok",
  "Via een vriend",
  "Bestaande klant",
  "Anders",
];
